<template>
    <div>

        <!-- 0. Top -->
        <div class="TQ_padding_4px TQ_text_28px TQ_margin_bottom_2px TQ_bg_purple_lite">

            <div v-if="selectedRiddleIndex_n == null && selectedLastRiddleIndex_n == null " class="TQ_grid_verticalCenter">
                {{ass_strings.oneWord_map[p_system_langCode_e]}}
            </div>

            <div v-else class="TQ_grid_col_1frAuto">
                <div class="TQ_grid_verticalCenter">
                    {{ass_strings.oneWord_mission[p_system_langCode_e]}}
                </div>

                <img class="TQ_width_28px TQ_grid_verticalCenter TQ_clickable"
                     :src="ass_img_leftArrow_w"
                     @click="selectedRiddleIndex_n = null; selectedLastRiddleIndex_n = null"/>
            </div>
        </div>

        <!-- 1. Map -->
        <div v-if="selectedRiddleIndex_n == null && selectedLastRiddleIndex_n == null" class="TQ_height_450px TQ_scrollable">

            <!--polygon map -->
            <tq-polygons-map-missions v-if="co_showPolygonsAreaMap_b"
                                      :p_quest-body_c="p_questBody_c"
                                      :p_system_lang-code_e="p_system_langCode_e"
                                      p_map-height_s="250px"

                                      :p_players-location_by-user-id_c="p_playersLocation_byUserId_c"
                                      :p_current-points_by-riddle-id_n="p_currentPoints_byRiddleId_n"
                                      :p_gst_missions-arrangement-index_n="p_gst_missionsArrangementIndex_n"
                                      :p_riddles-status_by-riddle-id_n="p_ts_riddles_byRiddleId_c"

                                      :pe_click-mission_f="m_clickMission_f"
            />

            <!--regular map-->
            <div v-else slot="body" class="TQ_height_100p lc_root">

                <tq-leaflet-display
                        class="TQ_height_100p"

                        :p_display_lang-code_e="p_questBody_c.cm_qb_getDisplayLangCode_e(p_system_langCode_e)"

                        :p_map-data_c="p_questBody_c.qb_mapData_c"
                        :p_map-type_e="p_questBody_c.qb_metadata_c.qbm_mapMissions_mapType2_e"
                        :p_polygons_ac="p_questBody_c.qb_mapData_c.md_polygons_ac"

                        :p_missions_ac="p_questBody_c.qb_mapMissions_ac"
                        :p_finish-missions-indexes_an="p_showOverlayImagesIndex_a"
                        :p_map-mission-type_e="p_questBody_c.qb_metadata_c.qbm_mapMissions_missionsType_e"

                        :p_players-location_by-user-id_c="p_playersLocation_byUserId_c"

                        :pf_two-fingers-movement_b="true"

                        :pe_on-click-mission_f="m_clickMission_f"
                        :pe_click-polygon_f="m_clickPolygon_f"
                />

                <div class="lc_finishRiddle TQ_bg_white TQ_padding_4px TQ_borderRadius TQ_box_shadow TQ_clickable"
                     v-if="p_questBody_c.qb_metadata_c.qbm_quest_supportMapLastMissions_b"
                     @click="selectedLastRiddleIndex_n=0">
                    <tq-notification-container :num="p_mapLastMissionsNotification_n">
                        <img :src="ass_img_puzzle_c" class="TQ_width_40px"/>
                    </tq-notification-container>
                </div>
                {{selectedLastRiddleIndex_n}}

            </div>

        </div>

        <!-- 2. selected mission -->
        <div v-if="selectedRiddleIndex_n != null" class="TQ_bg_white TQ_height_450px TQ_scrollable">

            <tq-riddle-data_-war-room
                    class="TQ_padding_8px"
                    :p_name_s="selectedRiddleIndex_n + ''"
                    :p_qb_display-lang-code_e="p_questBody_c.cm_qb_getDisplayLangCode_e(p_system_langCode_e)"

                    :p_qb_riddle_c="p_questBody_c.qb_mapMissions_ac[selectedRiddleIndex_n]"
                    :p_riddle-status_c="p_ts_riddles_byRiddleId_c[p_questBody_c.qb_mapMissions_ac[selectedRiddleIndex_n].qbr_riddleId_n]"
                    :p_qb_metadata_c="p_questBody_c.qb_metadata_c"

                    :p_clues-left_n="0"
                    :p_skips-left_n="0"

                    :pe_update-lock-status_f="(lockId_n, lockData_c, lockStatus_e, cb_f) => {pe_update_riddles_LockStatus_f(p_questBody_c.qb_mapMissions_ac[selectedRiddleIndex_n].qbr_riddleId_n, lockId_n, lockData_c, lockStatus_e, cb_f)}"

            />
        </div>

        <!-- all missions-->
        <div v-if="selectedLastRiddleIndex_n != null" class="TQ_bg_white TQ_height_450px TQ_scrollable">

            <div class="TQ_grid_col_Auto1frAuto TQ_bg_gray4">
                <div class="TQ_width_32px TQ_padding_4px">
                    <tq-image :pb_src_r="ass_img_rightArrow_b" class="TQ_clickable TQ_width_100p"
                              @click.native="selectedLastRiddleIndex_n--"
                              v-if="selectedLastRiddleIndex_n > 0 "/>
                </div>
                <div class="TQ_grid_verticalCenter TQ_text_20px TQ_direction_ltr">
                    {{selectedLastRiddleIndex_n+1}} / {{p_questBody_c.qb_mapLastMissions_ac.length}}
                </div>
                <div class="TQ_width_32px TQ_padding_4px">
                    <tq-image :pb_src_r="ass_img_leftArrow_b" class="TQ_clickable TQ_width_100p"
                              @click.native="selectedLastRiddleIndex_n++"
                              v-if="selectedLastRiddleIndex_n < p_questBody_c.qb_mapLastMissions_ac.length-1"/>
                </div>
            </div>

            <tq-riddle-data_-war-room
                    class="TQ_padding_8px"
                    :p_name_s="selectedLastRiddleIndex_n + ''"
                    :p_qb_display-lang-code_e="p_questBody_c.cm_qb_getDisplayLangCode_e(p_system_langCode_e)"

                    :p_qb_riddle_c="p_questBody_c.qb_mapLastMissions_ac[selectedLastRiddleIndex_n]"
                    :p_riddle-status_c="p_ts_lastRiddles_byRiddleId_c[p_questBody_c.qb_mapLastMissions_ac[selectedLastRiddleIndex_n].qbr_riddleId_n]"
                    :p_qb_metadata_c="p_questBody_c.qb_metadata_c"

                    :p_clues-left_n="0"
                    :p_skips-left_n="0"

                    :pe_update-lock-status_f="(lockId_n, lockData_c, lockStatus_e, cb_f) => {pe_update_lastRiddles_LockStatus_f(p_questBody_c.qb_mapLastMissions_ac[selectedLastRiddleIndex_n].qbr_riddleId_n, lockId_n, lockData_c, lockStatus_e, cb_f)}"
            />
        </div>


    </div>
</template>

<script>
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {
        enum_langCodes,
        enum_mapMissionsTypes,
    } from "../../../../../functions/src/shareCode/Share_S_Enum";
    import {validator_enum_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import TqRiddleData         from "../../../../components/complex/TqRiddleData";
    import TqLeafletDisplay            from "../../../../components/maps/TqLeafletDisplay";
    import TqRiddleData_WarRoom from "../../../../components/complex/TqRiddleData_WarRoom";
    import {
        ass_img_checked, ass_img_arrow_left_b,
        ass_img_arrow_left_w,
        ass_img_oneStar_w,
        ass_img_puzzle_c,
        ass_img_arrow_right_b
    } from "../../../../assets/scripts/Ass_Files";
    import {validator_objClass_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import TqOnTopContainer from "../../../../components/basic/TqOnTopContainer";
    import TqImage from "../../../../components/basic/TqImage";
    import TqPolygonsMapMissions from "../../../../components/complex/TqPolygonsMapMissions";
    import TqNotificationContainer from "../../../../components/basic/TqNotificationContainer";
    import {
        FB_QuestBody,
        FB_RiddleStatus
    } from "../../../../../functions/src/shareCode/Share_S_Classes";
    import {FB_MapPlayerLocation} from "@/classes/client_classes";

    export default {
        name: "c_Creator_Events_Item_Map",
        components: {
            TqNotificationContainer,
            TqPolygonsMapMissions,
            TqImage,
            TqOnTopContainer,
            TqRiddleData_WarRoom,
            TqRiddleData,
            TqLeafletDisplay
        },
        props:{

            p_system_langCode_e:{
                type:String,
                require:true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
            p_questBody_c:{
                type:FB_QuestBody,
                require:true,
            },
            p_mapLastMissionsNotification_n :{
                type:Number,
                default: 0
            },
            p_showOverlayImagesIndex_a :{
                type: Array,
                default() {return []}
            },
            p_playersLocation_byUserId_c :{
                type: Object,
                validator(obj){
                    return validator_objClass_fb(obj, FB_MapPlayerLocation)
                },
                default(){
                    return {}
                }
            },
            p_ts_riddles_byRiddleId_c:{
                type: Object,
                require:true,
                validator(obj){
                    return validator_objClass_fb(obj, FB_RiddleStatus)
                }
            },
            p_ts_lastRiddles_byRiddleId_c:{
                type: Object,
                require:true,
                validator(obj){
                    return validator_objClass_fb(obj, FB_RiddleStatus)
                }
            },

            pe_update_riddles_LockStatus_f:{
                type: Function,
                require: true
            },
            pe_update_lastRiddles_LockStatus_f:{
                type: Function,
                require: true
            },

            // pass props
            p_currentPoints_byRiddleId_n:{},
            p_gst_missionsArrangementIndex_n:{},

        },
        data(){
            return {
                selectedRiddleIndex_n : null,
                selectedLastRiddleIndex_n : null,
                missionCurrentPoints_byRiddleId_n : {},

                ass_strings : ass_strings,
                ass_img_leftArrow_w : ass_img_arrow_left_w,
                ass_img_leftArrow_b : ass_img_arrow_left_b,
                ass_img_rightArrow_b : ass_img_arrow_right_b,
                ass_img_oneStar_w : ass_img_oneStar_w,
                ass_img_checked : ass_img_checked,
                ass_img_puzzle_c : ass_img_puzzle_c,
            }
        },
        computed:{
            co_showPolygonsAreaMap_b(){
                return this.p_questBody_c.qb_metadata_c.qbm_mapMissions_missionsType_e === enum_mapMissionsTypes.polygons_area
            },
            co_showPolygonsMap_b(){
                return this.p_questBody_c.qb_metadata_c.qbm_mapMissions_missionsType_e === enum_mapMissionsTypes.polygons
            }
        },
        methods:{
            m_clickPolygon_f(index_n){
                if(this.co_showPolygonsMap_b){
                    this.selectedRiddleIndex_n = index_n
                }
            },
            m_clickMission_f(index_n){
                this.selectedRiddleIndex_n = index_n
            },
            m_click_lastRiddles_f(){

            }
        },

    }
</script>

<style scoped lang="scss">
    .lc_lastMissionsIcon{
        margin-top: 0;
    }

    .lc_root{
        position: relative;
    }

    .lc_finishRiddle{
        position: absolute;
        bottom: 8px;
        left: 8px;
    }
</style>